import store from '../store/store'
import axios from '../axios'

export default class QuotationService {

  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------After lazy loading--------------------
  // ----------------------------------------------
  // ----------------------------------------------
  

  getQuotations(filterId, page, rows, sortField, sortOrder, searchText, filterbody) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotationfilterbypage/' + filterId + '/' + page + '/' +  rows + '/' +  sortField + '/' +  sortOrder + '/' + searchText
        var response = await axios.post(path, filterbody)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // ----------------------------------------------
  // ----------------------------------------------
  // ----------------------------------------------
  // --------Before Lazy loading-------------------
  // ----------------------------------------------
  // ----------------------------------------------


  changeQuoteStatus(id, obj) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/updateQuoteStatus/' + id
        
        var response = await axios.put(path, obj)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  setQuoteStatusActive(quoteVerId, userId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/setquoteactive/' + quoteVerId + '/' + userId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  gatSavedFilteredQuotations(filterId) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/savedFilteredQuotations/' + filterId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  quotationGlobalSearch(text) {
    return new Promise(async function (resolve, reject) {
      try {
        var path = '/v1/quotationGlobalSearch/' + text
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  getLostStatusReasonsByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeLostQuoteNotes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/activelostquotenotes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getLostStatusReasons() {
    return new Promise(async (resolve, reject) => {
      if (store.getters[`commons/activelostquotenotes`]) {
        resolve(store.getters[`commons/activelostquotenotes`])
  
      } else {
        try {
          var path = '/v1/activeLostQuoteNotes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/activelostquotenotes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }

  getQuotationHistory(id) {
    return new Promise(async (resolve, reject) => {
      try {
        var path = '/v1/recordHistoryQuote/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getQuotationAttachments(quoteVerNo) {
    return new Promise(
      async (resolve, reject) => {
        try {
          var path = '/v1/quotationattachments/' + quoteVerNo
          
          var response = await axios.get(path)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    )
  }

  getQuotationActivities(quoteVerNo) {
    return new Promise(
      async (resolve, reject) => {
        try {
          var path = '/v1/quotationactivities/' + quoteVerNo
          
          var response = await axios.get(path)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    )
  }

  // oppId scopes the versions to ONE enquiry. The 30 historical duplicate pairs share
  // an sQuoteNo across two customers, so matching on the number alone returns the other
  // customer's versions too.
  getQuotationVersions(sQuoteNo, oppId) {
    return new Promise(
      async (resolve, reject) => {
        try {
          var path = '/v1/quotationversions/' + sQuoteNo
          if (oppId) path += '?oppId=' + oppId
          
          var response = await axios.get(path)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    )
  }

  getQuotationInfo(quoteVerNo) {
    return new Promise(
      async (resolve, reject) => {
        try {
          var path = '/v1/quotationinfo/' + quoteVerNo
          
          var response = await axios.get(path)
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    )
  }

  //MBP
  getAllActiveQuotations() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activequotations'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllQuotations() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotations'
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  // See getQuotationVersions — oppId keeps the next version number within this enquiry.
  getVersionNumber(sQuoteNo, oppId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotenextverno/' + sQuoteNo
        if (oppId) path += '?oppId=' + oppId
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  setQuoteAsActive(quoteVerId) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/setquoteactive/' + quoteVerId
        
        var response = await axios.get(path)
        // 
        resolve(response)
      } catch (err) {
        
        reject(err)
      }
    });
  }

  getQuotation(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotation/' + id
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  getAllQuotationTypes() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotetypes'
        
        var response = await axios.get(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  postQuotationTypes(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotetypes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putQuotationTypes(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotetypes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteQuotationTypes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotetypes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllManufacturersByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/manufacturers'
        var response = await axios.get(path)
        try {
          store.dispatch(`commons/manufacturers`, response.data)
        } catch(e) {}
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  postManufacturer(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/manufacturers'
        var response = await axios.post(path, data)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  putManufacturer(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/manufacturers/' + id
        var response = await axios.put(path, data)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  deleteManufacturer(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/manufacturers/' + id
        var response = await axios.delete(path)
        resolve(response.data)
      } catch (err) {
        reject(err)
      }
    })
  }
  getAllActiveManufacturersByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeManufacturers'
        var response = await axios.get(path)
        try {
          store.dispatch(`commons/activemanufacturers`, response.data)
        } catch(e) {}
        resolve(response.data)
      } catch (err) {     
        reject(err)
      }
    })
  }
  getAllActiveQuotationStatusesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/activeQuoteStatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/activequotestatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })

  }
  getAllActiveQuotationStatuses() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/activequotestatuses`]) {
        resolve(store.getters[`commons/activequotestatuses`])
  
      } else {
        try {
          var path = '/v1/activeQuoteStatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/activequotestatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  getAllQuotationStatusesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotestatuses'
        
        var response = await axios.get(path)

        try {
          store.dispatch(`commons/quotestatuses`, response.data)
        } catch(e) {}

        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllQuotationStatuses() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/quotestatuses`]) {
        resolve(store.getters[`commons/quotestatuses`])
  
      } else {
        try {
          var path = '/v1/quotestatuses'
          
          var response = await axios.get(path)
  
          try {
            store.dispatch(`commons/quotestatuses`, response.data)
          } catch(e) {}
  
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })

  }
  postQuotationStatus(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotestatuses'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  putQuotationStatus(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotestatuses/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteQuotationStatus(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/quotestatuses/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  
  getAllLostQuoteNotesByHard() {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/lostquotenotes'
        
        var response = await axios.get(path)
        
        try {
          store.dispatch(`commons/lostquotenotes`, response.data)
        } catch(e) {}
        
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  getAllLostQuoteNotes() {
    return new Promise(async function(resolve, reject) {
      if (store.getters[`commons/lostquotenotes`]) {
        resolve(store.getters[`commons/lostquotenotes`])
  
      } else {
        try {
          var path = '/v1/lostquotenotes'
          
          var response = await axios.get(path)
          
          try {
            store.dispatch(`commons/lostquotenotes`, response.data)
          } catch(e) {}
          
          // 
          resolve(response.data)
        } catch (err) {
          
          reject(err)
        }
      }
    })
  }
  postLostQuoteNotes(data) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/lostquotenotes'
        
        var response = await axios.post(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
    
  putLostQuoteNotes(data, id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/lostquotenotes/' + id
        
        var response = await axios.put(path, data)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }
  deleteLostQuoteNotes(id) {
    return new Promise(async function(resolve, reject) {
      try {
        var path = '/v1/lostquotenotes/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }


  saveQuotation(quotation) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/quotation'
        
        var response = await axios.post(path, quotation)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  updateQuotation(id, quotation) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/quotation/' + id
        
        var response = await axios.put(path, quotation)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteQuotation(id) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/quotation/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }

  deleteQuotationWithRelatedRecords(id) {
    return new Promise(async function(resolve, reject) {
      try {
        
        var path = '/v1/delQuoteRelRec/' + id
        
        var response = await axios.delete(path)
        // 
        resolve(response.data)
      } catch (err) {
        
        reject(err)
      }
    })
  }


}
